import Container from '~/components/container';
import * as St from '../../styles';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/input';
import Button from '~/components/button';
import { BsSearch } from 'react-icons/bs';
import TableList from '~/components/tableList';
import { IListColumn } from '~/models/listCol';
import { useEffect, useState } from 'react';
import Dialog from '~/components/dialog';
import { icons } from '~/assets';
import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';
import Pagination from '~/components/pagination';
import Loading from '~/components/loading';
import { cpfMask } from '~/utils/masks';
import { useHistory } from 'react-router-dom';
import { OriginBiometrics } from '../..';

interface Customer {
  blocked: boolean;
  changeDate: string;
  code: string;
  countRejects: number;
  createdDate: string;
  customerName: string;
  expiryDate: string;
  flow: string;
  id: string;
  lastStatus: string;
  tenantId: string;
}

export interface IListBlockUsers {
  data: Customer[];
  totalPages: number;
  size: number;
  page: number;
}

const UnlockBiometrics = () => {
  const [dataUnlock, setDataUnlock] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogSuccess, setDialogSuccess] = useState(false);
  const [dialogError, setDialogError] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [form, setForm] = useState({
    nome: '',
    cpf: cpfMask(''),
  });

  const history = useHistory();

  const RequestListBlock = useApi<IListBlockUsers>(
    Endpoints.integration.getListUserBlock,
    ApiMethod.GET,
    {},
    true,
  );

  const RequestUserUnlock = useApi(
    Endpoints.integration.putUnlockUser.replace('PARAM_ID', selectedId),
    ApiMethod.PUT,
  );

  const customHeaderUnlock = [
    {
      id: 1,
      value: 'Nome completo',
      maxChar: 20,
      textAlign: 'center',
    },
    {
      id: 2,
      value: 'CPF',
      maxChar: 20,
      textAlign: 'center',
    },
    {
      id: 3,
      value: 'Quantidade de tentativas',
      maxChar: 20,
      textAlign: 'center',
    },
    {
      id: 4,
      value: 'Ultima origem da biometria',
      maxChar: 20,
      textAlign: 'center',
    },
    {
      id: 5,
      value: 'Ação',
      maxChar: 10,
      textAlign: 'center',
    },
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (page = 1, name = '', cpf = '') => {
    setCurrentPage(page);
    getUnlocksBiometrics(page, 10, name, cpf);
  };

  useEffect(() => {
    getUnlocksBiometrics();
  }, [currentPage]);

  const getUnlocksBiometrics = async (
    page = 1,
    size = 10,
    nome = '',
    cpf = '',
  ) => {
    const response = await RequestListBlock.callApi({
      page,
      size,
      nome,
      cpf,
    });
    const { data } = response.data;

    const newList = [];

    if (response.status >= 200 && response.status < 300) {
      data.forEach((customer) => {
        const item: IListColumn[] = [
          {
            value: customer?.customerName ? customer?.customerName : '-',
            textAlign: 'center',
            maxChar: 20,
          },
          {
            value: customer?.code ? cpfMask(customer?.code).masked : '-',
            textAlign: 'center',
            maxChar: 20,
          },
          {
            value: customer?.countRejects ? customer.countRejects : '-',
            textAlign: 'center',
            maxChar: 20,
          },
          {
            value: customer?.flow ? OriginBiometrics(customer?.flow) : '-',
            textAlign: 'center',
            maxChar: 20,
            border: true,
          },
          {
            item: customer || [],
            maxChar: 30,
            border: true,
            textAlign: 'center',
            action3: (id, item) => {
              setDialogOpen(true);
              setSelectedId(id);
            },
          },
        ];
        newList.push(item);
      });
    } else if (response.status >= 400) {
      setDialogError(true);
      setDialogMessage('Ocorreu um erro');
    }

    setDataUnlock(newList);
  };

  const handleUnlockCustomer = async () => {
    const response = await RequestUserUnlock.callApi();
    if (response.status >= 200 && response.status < 300) {
      setDialogSuccess(true);
      setDialogMessage('Cliente Desbloqueado!');
      getUnlocksBiometrics(currentPage, 10);
    } else {
      setDialogError(true);
      setDialogMessage('Ocorreu um erro ao desbloquear cliente');
      getUnlocksBiometrics(currentPage, 10);
    }
  };

  return (
    <>
      <Loading status={RequestListBlock.loading || RequestUserUnlock.loading} />
      <Dialog
        icon={icons.exclamation}
        open={dialogOpen}
        message="Deseja realmente desbloquear este cliente?"
        positiveAction={() => {
          handleUnlockCustomer();
        }}
        positiveLabel="SIM"
        negativeAction={() => setDialogOpen(false)}
        negativeLabel="NÃO"
      />
      <Dialog
        icon={icons.check}
        open={dialogSuccess}
        message={dialogMessage}
        positiveAction={() => {
          setDialogSuccess(false);
          setDialogOpen(false);
          history.push('/consult/user/biometrics');
        }}
        positiveLabel="Entendi"
      />
      <Dialog
        icon={icons.exclamation}
        open={dialogError}
        message={dialogMessage}
        positiveAction={() => {
          setDialogError(false);
          setDialogOpen(false);
          getUnlocksBiometrics(currentPage, 10);
        }}
        positiveLabel="Entendi"
      />
      <Container>
        <St.BoxCard>
          <ContainerFlex row space gap="200">
            <ContainerFlex marginRight={16} space gap="20" row>
              <Input
                label="CPF"
                name="cpf"
                maxLength={14}
                placeholder="000.000.000-00"
                value={form.cpf.masked}
                mask={MaskTypes.CPF}
                onChange={handleChange}
              />
              <Input
                label="Nome"
                value={form.nome}
                onChange={handleChange}
                name="nome"
              />
            </ContainerFlex>
            <ContainerFlex maxWidth={20} row gap="10">
              <Button
                style={{ display: 'inline-flex', gap: 8 }}
                onClick={() =>
                  handleSubmit(currentPage, form.nome, form.cpf.unmasked)
                }
              >
                <BsSearch style={{ marginRight: 4 }} />
                <span>Consultar</span>
              </Button>
              {/* <Button
                outlined
                onClick={() => history.goBack()}
                style={{ display: 'inline-flex', gap: 8 }}
              >
                <span>Voltar</span>
              </Button> */}
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>
        {dataUnlock.length > 0 ? (
          <St.BoxCard>
            <ContainerFlex center>
              <TableList
                customerHeader={customHeaderUnlock}
                list={dataUnlock}
              />
            </ContainerFlex>
            {RequestListBlock.data.totalPages > 1 && (
              <Pagination
                totalPages={RequestListBlock.data.totalPages}
                onCurrentPageChange={(e) => setCurrentPage(e)}
              />
            )}
          </St.BoxCard>
        ) : (
          <St.BoxCard>
            <ContainerFlex center>
              <span>Dados biométricos não encontrados</span>
            </ContainerFlex>
          </St.BoxCard>
        )}
      </Container>
    </>
  );
};

export default UnlockBiometrics;
